<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50">
    <!-- style="height: 50vh" -->
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row h-5/6">
      <!-- Formulário -->
      <div class="w-full p-10">
        <form class="" [formGroup]="formDevicesAtendente">
          <div class="grid w-full grid-cols-2 gap-4">
            <div class="form-group">
              <label for="name" class="input-label">Nome*</label>
              <input type="text" class="form-input" formControlName="fullName" id="name" />
            </div>

            <div class="form-group">
              <label for="devices" class="input-label">Dispositivos*</label>
              <ng-select notFoundText="Nenhum item encontrado" [items]="devices" [searchable]="true"
                placeholder="Dispositivos" formControlName="devices" bindLabel="name" bindValue="id" [multiple]="true">
              </ng-select>
            </div>
          </div>
        </form>
      </div>

      <!-- Menu Lateral -->
      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto sm:w-auto">
        <button class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/atendentes">
          X
        </button>

        <button *isAllowed="[ERoleAdminString.Admin, 'attendants.edit']" class="sm:px-2 lg:mb-5 btn btn--secondary"
          (click)="editarAtendente()">
          Salvar Cadastro
        </button>
      </div>
    </div>
  </div>
</div>